import { render, staticRenderFns } from "./UserPasswordModal.vue?vue&type=template&id=493f8d68&lang=html&"
import script from "./UserPasswordModal.vue?vue&type=script&lang=js&"
export * from "./UserPasswordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports